const PENDING_CALL_ACTION_KEY = 'videocall.pendingCallAction';
const PENDING_CALL_ACTION_MAX_AGE_MS = 20_000;

const handledPendingCallActions = new Map<string, number>();

export type PendingCallAction = {
  callSessionId: string;
  action: 'answer' | 'reject';
  serverId?: string;
  at: number;
};

export function readPendingCallAction(): PendingCallAction | null {
  try {
    const raw = sessionStorage.getItem(PENDING_CALL_ACTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const callSessionId = String(parsed.callSessionId || '');
    const action = parsed.action;
    if (!callSessionId) return null;
    if (action !== 'answer' && action !== 'reject') return null;
    const result = {
      callSessionId,
      action,
      serverId: parsed.serverId ? String(parsed.serverId) : undefined,
      at: Number(parsed.at || Date.now())
    };
    if (!Number.isFinite(result.at) || Date.now() - result.at > PENDING_CALL_ACTION_MAX_AGE_MS) {
      clearPendingCallAction();
      return null;
    }
    return result;
  } catch {
    return null;
  }
}

export function clearPendingCallAction() {
  try {
    sessionStorage.removeItem(PENDING_CALL_ACTION_KEY);
  } catch {
    // ignore
  }
}

export function rememberHandledPendingCallAction(callSessionId: string, action: PendingCallAction['action']) {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return;
  handledPendingCallActions.set(`${cleanCallSessionId}:${action}`, Date.now() + 20_000);
}

export function shouldIgnoreHandledPendingCallAction(callSessionId: string, action: PendingCallAction['action']): boolean {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return false;

  const now = Date.now();
  for (const [key, expiresAt] of handledPendingCallActions.entries()) {
    if (expiresAt <= now) {
      handledPendingCallActions.delete(key);
    }
  }

  const actionKey = `${cleanCallSessionId}:${action}`;
  const expiresAt = handledPendingCallActions.get(actionKey);
  if (!expiresAt) return false;
  if (expiresAt <= now) {
    handledPendingCallActions.delete(actionKey);
    return false;
  }
  return true;
}
